import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { enviarEmail } from '../send/sendEmail'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

export function Contact(ts) {
    const { i18n } = ts;
    const texto = i18n['t']
    const obj = i18n['i18n']

    const validacao = Yup.object().shape({
        Name: Yup.string().required('O name is required'),
        LastName: Yup.string().required('O last name is required'),
        Email: Yup.string().email('E-mail inválido').required('O e-mail is required'),
    })
    const MySwal = withReactContent(Swal)
    return (
        <>
            <section id="contact" className="text-gray-700 body-font relative">
                <Formik
                    initialValues={{
                        Name: '',
                        Email: '',
                        LastName: '',
                        Msg: '',
                        Subject: 'Site Willian',
                        Template: 'Site Willian',
                    }}
                    onSubmit={(values, { resetForm }) => {
                        enviarEmail(values)
                        MySwal.fire({
                            icon: 'success',
                            title:
                              'Email successfully sent',
                            width: 400,
                            text: '',
                            allowOutsideClick: true,
                            confirmButtonText: 'Ok'
                          })
                        resetForm()
                    }}
                    validationSchema={validacao}
                >
                    {({
                        values,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        errors,
                        touched,
                        resetForm
                    }) => (
                        <form className="w-full" onSubmit={handleSubmit}>
                            <div className="max-w-screen-md mx-auto p-5">
                                <div className="text-center mb-6">
                                    <p className="mt-4 text-sm leading-7 text-gray-500 font-regular uppercase">
                                        {texto('contact')}
                                    </p>
                                    <h3 className="text-3xl sm:text-4xl leading-normal font-extrabold tracking-tight text-gray-900">
                                        {texto('contact_1')}  <span className="text-sky-500">{texto('contact_2')} </span>
                                    </h3>
                                </div>

                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                        <label name="Name" className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-first-name">
                                            {texto('contact_3')}</label>
                                        <input
                                            className="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                            name="Name"
                                            onChange={handleChange}
                                            value={values.Name}
                                            type="text"
                                            placeholder="Name" />
                                        {errors.Name && touched.Name ? (<div>{' '}<p className="text-red-600">{errors.Name}</p>{' '}</div>) : null}
                                    </div>
                                    <div className="w-full md:w-1/2 px-3">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-last-name">
                                            {texto('contact_4')}
                                        </label>
                                        <input
                                            className="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                            name="LastName"
                                            onChange={handleChange}
                                            value={values.LastName}
                                            type="text"
                                            placeholder="last name" />
                                        {errors.LastName && touched.LastName ? (<div>{' '}<p className="text-red-600">{errors.LastName}</p>{' '}</div>) : null}
                                    </div>
                                </div>
                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full px-3">
                                        <label
                                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-password">

                                            {texto('contact_5')}
                                        </label>
                                        <input
                                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                            type="email"
                                            placeholder="********@*****.**"
                                            name="Email"
                                            onChange={handleChange}
                                            value={values.Email} />
                                        {errors.Email && touched.Email ? (<div>{' '}<p className="text-red-600">{errors.Email}</p>{' '}</div>) : null}
                                    </div>
                                </div>

                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full px-3">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-password">
                                            {texto('contact_6')}
                                        </label>
                                        <textarea
                                            rows="5"
                                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                            name="Msg"
                                            onChange={handleChange}
                                            value={values.Msg}
                                        >
                                        </textarea>
                                    </div>
                                    <div className="flex justify-between w-full px-3">
                                        <div className="md:flex md:items-center">
                                        </div>
                                        <button
                                            className="shadow bg-sky-500 hover:bg-sky-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-6 rounded"
                                            type="submit">
                                            {texto('contact_7')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    )}
                </Formik>
            </section>
        </>
    );


}
